<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="confirm">
    <v-card>
      <v-card-title primary-title>
        Byt lösenord
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              filled
              label="Nytt lösenord"
              type="password"
              hide-details
              :rules="[rules.required]"
              v-model="model.newPassword"
              placeholder="Skriv in nytt lösenord"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              filled
              label="Nytt lösenord igen"
              type="password"
              hide-details
              :rules="[rules.required]"
              v-model="model.newPasswordConfirm"
              placeholder="Skriv in nytt lösenord igen"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="errors.length">
          <v-col>
            <p class="error--text" v-for="(error, $i) in errors" :key="$i">
              {{ error }}
            </p>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn tile text @click="close">
          Stäng
        </v-btn>
        <v-btn
          tile
          class="primary"
          text
          type="submit"
          :loading="pendingPasswordUpdate"
        >
          Bekräfta
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import rules from '@/common/validationRules.js'
import gql from 'graphql-tag'

export default {
  name: 'UserChangePasswordModal',

  data() {
    return {
      valid: true,
      rules,
      pendingPasswordUpdate: false,
      model: {
        newPassword: '',
        newPasswordConfirm: ''
      }
    }
  },

  computed: {
    errors() {
      const errors = []

      if (this.model.newPassword !== this.model.newPasswordConfirm) {
        errors.push('Lösenorden måste vara identiska')
      }

      return errors
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },

    async confirm() {
      const isValid = await this.$refs.form.validate()

      if (!isValid || this.errors.length) return

      this.pendingPasswordUpdate = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation updatePassword($password: String!) {
            updatePassword(password: $password)
          }
        `,

        variables: {
          password: this.model.newPassword
        }
      })

      this.pendingPasswordUpdate = false
      this.close()
    }
  }
}
</script>
